import { gql } from '@apollo/client'

export const VISUAL_SEARCH = gql`
  query VisualSearch($input: VisualSearchInput!) {
    visualSearch(input: $input) {
      cursor
      image {
        id
        imageUrl
        bucketPath
        imageSource
        sourceCustomer
        created
        acquisitionScore
        focusScore
        detectionEntropyScore
        recencyScore
        unidentifiedCount
        boxCount
        closeConfidenceCount
        verifiedBoxCount
        unverifiedBoxCount
      }
      box {
        id
        minX
        maxX
        minY
        maxY
        metaClass
        detectionConfidence
        isHumanAdded
        isHumanDeleted
        verifiedUpc
        upcVerifiedAt
        isVerified
        currentUpc
        classifierScoreMargin
        acquisitionScore
        focusScore
        pixelArea
        isUnidentified
        predictedUpcs {
          upc
          classifierScore
          classifierRank
          displayIndex
          isFieldLabeled
        }
      }
    }
  }
`
